import React from "react";
import "./InternshipButton.css";

const InternshipButton = () => {
  return (
    <>
      <a href="/internship-program">
        <div className="internship-bar">
          <div className="internship-text">Internship Program</div>
        </div>
      </a>
    </>
  );
};

export default InternshipButton;
